import $ from "jquery";

jQuery(function ($) {
  const $keywordInput = $("#recruitment-search-keyword");
  const $citySelect = $("#recruitment-search-city");
  const $submitBtn = $("#recruitment-search-submit");
  const $wrapper = $("#recruitment-ajax-wrapper");

  if (!$keywordInput.length && !$citySelect.length) {
    return;
  }

  let searchTimeout = null;

  function doSearch(page = 1) {
    $wrapper.addClass("is-loading").css("opacity", 0.6);

    const keyword = $keywordInput.val();
    const city = $citySelect.val();
    const ajaxUrl = window.hdConfig?._ajaxUrl || "/wp-admin/admin-ajax.php";

    $.ajax({
      url: ajaxUrl,
      type: "POST",
      dataType: "json",
      data: {
        action: "ajax_recruitment_search",
        keyword: keyword,
        city: city,
        page: page
      },
      success: function (response) {
        $wrapper.removeClass("is-loading").css("opacity", 1);
        if (response.success && response.data && response.data.html) {
          $wrapper.html(response.data.html);
        } else {
          $wrapper.html('<div class="no-results"><p>Đã có lỗi xảy ra. Vui lòng thử lại.</p></div>');
        }
      },
      error: function () {
        $wrapper.removeClass("is-loading").css("opacity", 1);
        $wrapper.html('<div class="no-results"><p>Đã có lỗi xảy ra. Vui lòng thử lại.</p></div>');
      }
    });
  }

  // Trigger search on keyword input (debounced)
  $keywordInput.on("input", function () {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(function () {
      doSearch(1);
    }, 400);
  });

  // Trigger search on city change
  $citySelect.on("change", function () {
    doSearch(1);
  });

  // Trigger search on submit button click
  $submitBtn.on("click", function (e) {
    e.preventDefault();
    doSearch(1);
  });

  // Handle AJAX pagination click
  $wrapper.on("click", ".page-numbers a, .pagination a", function (e) {
    e.preventDefault();
    const $link = $(this);
    let href = $link.attr("href");
    if (!href) return;

    let page = 1;
    const pagedMatch = href.match(/[?&]paged=(\d+)/) || href.match(/page\/(\d+)/);
    if (pagedMatch) {
      page = parseInt(pagedMatch[1]);
    } else {
      const segments = href.split('/');
      const pageIndex = segments.indexOf('page');
      if (pageIndex !== -1 && segments[pageIndex + 1]) {
        page = parseInt(segments[pageIndex + 1]);
      }
    }

    doSearch(page);

    $("html, body").animate({
      scrollTop: $wrapper.offset().top - 150
    }, 500);
  });
});
